import GiftCardLayout from './GiftCardLayout';
import enhance from './GiftCardLayoutContainer';

export default enhance(GiftCardLayout);



// WEBPACK FOOTER //
// ./src/app/giftCard/GiftCardLayout/index.js